import axios from 'axios';
import {notification} from 'antd';
import {API_BASE_URL, AUTH_TOKEN, CLOSE_SESSION, HOST_URL, HOST_URL_LOGOUT, REFRESH_TOKEN, NAME} from "./config";

const service = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`,
    timeout: 800000,
})

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';

// API Request interceptor
service.interceptors.request.use((config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);

    if (jwtToken) {
        config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${ jwtToken }`;
    }

    if (config?.formData) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (!jwtToken) {
            config.headers['Authorization'] = 'Basic ' + btoa("plan_abc:abc_clave");
        }
    }else{
        config.headers['Accept'] = 'application/json';
        config.headers['Content-Type'] = 'application/json';
    }

    // 👉 Agregar header "language" si existe lng-selected
    try {
        const lngSelected = localStorage.getItem('lng-selected');
        if (lngSelected) {
            const parsed = JSON.parse(lngSelected);
            if (parsed?.lanName) {
                config.headers['language'] = parsed.lanName;
            }
        }
    } catch (e) {
        // Silencio si el JSON está mal formado o falta lanName
    }

    return config
}, error => {
    // Do something with request error here
    notification.error({
        message: 'Error'
    })
    Promise.reject(error)
})

// API respone interceptor
let isRefreshing = false;
let refreshSubscribers = [];
service.interceptors.response.use( (response) => {
    return response
}, async (error) => {

    const { config, response: { status, data } } = error;
    const originalRequest = config;

    // Remove token and redirect
    if (status === 401) {
        if (!isRefreshing) {
            isRefreshing = true;
            const refresh_token = localStorage.getItem(REFRESH_TOKEN);
            if (refresh_token === "undefined" || refresh_token === undefined || refresh_token === null || refresh_token === '') {
                closeSession();
                return Promise.reject(data);
            }
            fetch(`${ API_BASE_URL }/security/oauth/token`, {
                method: 'POST',
                body: 'grant_type=refresh_token&refresh_token=' + refresh_token,
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }).then(res => res.json()).then((data) => {
                isRefreshing = false;
                if (data) {
                    if (data?.access_token && data?.refresh_token) {
                        localStorage.setItem(AUTH_TOKEN, data.access_token);
                        localStorage.setItem(REFRESH_TOKEN, data.refresh_token);
                        // authenticated(data.access_token);
                    } else {
                        closeSession();
                        return Promise.reject(data);
                    }
                }
                isRefreshing = false;
                const {access_token} = data;
                onRefreshed(access_token);
            }).catch(e=>{
                closeSession();
                return Promise.reject(data);
            });
        }

        return new Promise((resolve, reject) => {
            subscribeTokenRefresh(accessToken => {
                originalRequest.headers['authorization'] = 'Bearer ' + accessToken;
                resolve(axios(originalRequest));
            });
        });
    } else {
        return Promise.reject(data);
    }
});

export const closeSession = () => {
    // Only perform session closing in production or training environments, not in QA
    if (NAME === 'DEV') {
        console.log('Session closing disabled in DEV environment');
        return;
    }
    
    let oktaTokenId = localStorage.getItem('oktaTokenId')
    localStorage.clear();
    sessionStorage.clear();
    caches.delete();
    if(oktaTokenId != null){
        window.open(`${CLOSE_SESSION}?id_token_hint=${oktaTokenId}&post_logout_redirect_uri=${HOST_URL_LOGOUT}`, '_blank');
    }
    window.open(HOST_URL, '_self');
}

const subscribeTokenRefresh = (cb) => {
    refreshSubscribers.push(cb);
}

const  onRefreshed = (accessToken) => {
    refreshSubscribers.map(cb => cb(accessToken));
}

export default service
